import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from '../../components/sturtural/Menu';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { useParams } from "react-router";
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { useFormValidationProcess } from '../../hooks/useFormValidationProcess';
import Loader from '../../components/sturtural/Loader';
import MessageDetail from '../../components/sturtural/MessageDetail';
import HeaderInfoValidation from '../../components/demand/HeaderInfoValidation';
import { Dialog } from 'primereact/dialog';

const validationsFrom = (form) => {
    let errors = {};

    if(!form.mark) {
        errors.mark = "El Campo (Calificar el documento) es requerido";
    } else {
        if(form.mark.code === 'Rechazar') {
            if(!form.observaciones) {
                errors.observaciones = "Si ha seleccionado Rechazar el documento el campo (observaciones) es obligatorio";
            }
        }
    }

    return errors;
}

const DocumentValidationProcess = () => {
    const [db, setDb] = useState(null); 
    const [error, setError] = useState(true);
    const [loading, setLoading] = useState(false);
    const [forms, setForms] = useState(true);

    const navigate = useNavigate();


    let {solicitudid} = useParams();
    let {adjuntoid} = useParams();

    const initialForm = {
        observaciones: "",
        mark: "",
    }

    const {form, 
        errors,
        loadup,
        response,
        message,
        terminado,
        handleChange,
        handleBlur,
        handleSubmit} = useFormValidationProcess(initialForm, validationsFrom, adjuntoid);

    let url = `${BASE_API}demand/attachments/${solicitudid}/${adjuntoid}`;

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Access-Control-Allow-Origin': '*'
            }
        }).then(res => {
            if(!res.err) {
                setDb(res.attachment);
                setError(false);

                if([10, 11, 12, 13].includes(res.sol_statusid)) {
                    setForms(false);
                } else {
                    setForms(true);
                }
            } else {
                setDb(null);
                setError(false);
            }
            setLoading(false);
        });
    }, [url]);

    const handlerRedirect = (terminado) => {
        console.log("handlerRedirect: " + terminado);
        if(terminado) {
            navigate("/lista-solicitudes-validacion");
        } else {
            navigate("/validacion");
        }
    }

    const handleStatus = (status) => {

        let color;
        let icon;
        let textcolor;
        
        switch (status) {
            case 'Sin Documento':
                color = 'gray-100';
                textcolor = 'gray-600';
                icon = 'pi pi-question';
            break;
            
            case 'En Proceso':
                color = 'yellow-100';
                textcolor = 'yellow-600';
                icon = 'pi pi-play';
            break;
           
            case 'Aprobado':
                color = 'green-100';
                textcolor = 'green-600';
                icon = 'pi pi-check-circle';
            break;

            case 'Rechazado':
                color = 'orange-600';
                textcolor = 'orange-100';
                icon = 'pi pi-exclamation-triangle';
            break;
            
            case 'cancelado':
                color = 'gray-100';
                textcolor = 'gray-600';
                icon = 'pi pi-minus-circle';
            break;
            
            default:
                color = 'orange-100';
                textcolor = 'orange-600';
                icon = 'pi pi-bell';
            break;    
        }
       
        return (
                <div className="flex align-items-center">
                    <span className={`inline-flex border-circle align-items-center justify-content-center bg-${color} mr-3`} style={iconstyle}><i className={`${icon} text-xl text-${textcolor}`}></i></span>
                    <span className="text-900 font-medium text-2xl">{status}</span>
                </div>
        );
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect(terminado)} icon="pi pi-check" className="p-button-secondary" />;

    const dropdownItemsMark = [
        {name: 'Rechazar', code: "Rechazar"},
        {name: 'Aprobar', code: "Aprobar"}
    ] ;

    const iconstyle = {
        'width': "48px",
        'height': "48px",
        'borderRadius': "10px"
    };

    return (
        <>
            <Menu link='form-validacion' />

            <div className="grid">
                <div className="col-12">
                    <HeaderInfoValidation solicitud={solicitudid} />
                </div>

                {!error && 
                    <>
                        {forms && 
                        <div className="col-12 xl:col-3">
                            <div className="card">
                                <div className="flex align-items-center justify-content-between">
                                    <h5>Validar documento:</h5>
                                </div>
                                {handleStatus(db.status)}
                                <MessageDetail mensaje={db.documento} color='warn' />

                                <form onSubmit={handleSubmit}>
                                    <div className="p-fluid">
                                        <div className="field">
                                            <label htmlFor="mark">Calificar el documento</label>
                                            <Dropdown id="mark" name="mark" value={form.mark}  options={dropdownItemsMark} optionLabel="name" placeholder="Elige una opción" onChange={handleChange} onBlur={handleBlur} className={errors.mark && 'p-invalid'}></Dropdown>
                                            {errors.mark && <small className="p-error">{errors.mark}</small>}
                                        </div>
                                        <div className="field">
                                            <label htmlFor="observaciones">Observaciones:</label>
                                            <InputTextarea id="observaciones" name="observaciones" rows="2" value={form.observaciones.toUpperCase()} onChange={handleChange} onBlur={handleBlur} className={errors.observaciones && 'p-invalid'} />
                                            {errors.observaciones && <small className="p-error">{errors.observaciones}</small>}
                                        </div>
                                    </div>
                                    <div className="p-dialog-footer text-right">
                                        {loading && <Loader />}
                                        <Button type="submit" disabled={loading} label="Aceptar" className="p-button-rounded mr-2 mb-2" />
                                    </div>
                                </form>
                            </div>
                        </div>}

                        <div className={`col-12 xl:col-${(forms ? 9:12)}`}>
                            <div className="card">
                                <div className="flex align-items-center justify-content-between">
                                    <h5>{db.documento}</h5>
                                </div>
                                <small>{db.descripcion}</small>
                                <MessageDetail mensaje="FAVOR DE REVISAR EXHAUSTIVAMENTE EL DOCUMENTO PARA VALIDAR QUE CUMPLA CON LOS REQUISITOS" color='warn' />
                                {!!db.observacion && <MessageDetail mensaje={'OBSERVACIÓN: ' + db.observacion} color='error' />}
                                <iframe id="inlineFrameExample" title="Inline Frame Example" width="100%" height="680px" src={db.url_relativa}></iframe>
                            </div>
                        </div>
                    </>
                }
            </div>

            <Dialog header="Aviso" visible={response} style={{ width: '30vw' }} modal footer={basicDialogFooter} onHide={() => handlerRedirect(terminado)}>
                <p>{message}</p>
            </Dialog>
        </>
    )
}

export default DocumentValidationProcess;